<template>
  <div id="header-actions" class="full-view-header header-actions-wrapper bg-white flex flex-align-center flex-justify-between gap-1vw p-l-2rem p-r-2rem p-t-1rem p-b-1rem">
    <!-- Desktop Layout -->
    <div class="desktop flex flex-align-center flex-justify-between gap-1vw w-100">
      <div class="header-action-section flex-1 flex flex-align-center flex-justify-between gap-1vw">
        <button 
          class="body-base color-link font-bold hov-underline flex-shrink-0" 
          @click="$emit('back')"
        >
          &lt; Back
        </button>
        
        <div v-if="currentStep != 2" class="buttons-container w-100 flex flex-align-center gap-1vw">
          <button 
            @click="$emit('show-filters')" 
            class="hb-btn thick wp-nowrap link slim filters flex flex-align-center flex-justify-between gap-05vw"
          >
            <img 
              class="purple h-auto hov-primary-img" 
              width="15px" 
              height="15px" 
              src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
            />
            <img 
              class="purple h-auto hov-img" 
              width="15px" 
              height="15px" 
              src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_white.svg?v=1749590428"
            />
            Filters 
            <span v-if="!selectedCardsOccasions.includes('View All')">
              ({{ selectedCardsOccasions.length }})
            </span>
          </button>
          
          <button 
            v-if="currentStep == 1" 
            class="hb-btn thick wp-nowrap link slim filters flex flex-align-center flex-justify-between gap-05vw" 
            @click="$emit('show-sort')"
          >
            <img 
              width="15px" 
              height="10px" 
              class="h-auto hov-primary-img" 
              src="https://cdn.shopify.com/s/files/1/1363/8433/files/sort.svg?v=1749479130"
            />
            <img 
              width="15px" 
              height="10px" 
              class="h-auto hov-img" 
              src="https://cdn.shopify.com/s/files/1/1363/8433/files/sort_white.svg?v=1749590429"
            />
            Sort Products
          </button>
        </div>
      </div>
      
      <div class="header-action-section flex-1 flex flex-align-center flex-justify-center gap-1vw">
        <p class="body-base step-text wp-nowrap">{{ currentCopy }}</p>
        <p class="steps body-base flex-align-center flex-justify-center p-r-1rem flex-shrink-0">
          <span class="p-r-05rem flex-shrink-0">STEP {{ currentStep }} OF 4:</span>
          <span class="dot">
            <span :class="1 <= currentStep ? 'selected' : ''"></span>
          </span>
          <span class="dot">
            <span :class="2 <= currentStep ? 'selected' : ''"></span>
          </span>
          <span class="dot">
            <span :class="3 <= currentStep ? 'selected' : ''"></span>
          </span>
          <span class="dot">
            <span></span>
          </span>
        </p>
      </div>
      
      <div class="header-action-section between-sticky flex-1 flex flex-align-center flex-justify-end gap-1vw">
        <button 
          :disabled="!canNext" 
          @click="$emit('next')" 
          class="hb-btn primary p-l-unset p-r-unset sticky"
        >
          <span class="p-r-1rem p-l-1rem desktop">Next Step ></span>
          <span class="p-r-1rem p-l-1rem mobile">Next ></span>
        </button>
        
        <VDropdown :distance="6">
          <button 
            class="leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center" 
            v-tooltip="{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }" 
            @click="$emit('leave-builder')"
          >
            <span class="color-link font-bold">{{ headerText }} </span>
            <img 
              width="20" 
              height="20" 
              src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131" 
              alt="save cart"
            />
          </button>
          <template #popper>
            <p>Saved!</p>
          </template>
        </VDropdown>
      </div>
    </div>
    
    <!-- Mobile Layout -->
    <div class="mobile flex flex-align-center flex-justify-between gap-1vw flex-column w-100">
      <div class="header-action-section flex-1 flex flex-align-center flex-justify-center gap-1vw w-100">
        <button 
          class="body-base color-link font-bold hov-underline flex-shrink-0 flex-1" 
          @click="$emit('back')"
        >
          &lt; Back
        </button>
        
        <p class="body-base step-text wp-nowrap flex-2">{{ currentMobileCopy }}</p>
        
        <p class="steps body-base flex-align-center flex-justify-center p-r-1rem flex-shrink-0">
          <span class="p-r-05rem flex-shrink-0">STEP {{ currentStep }} OF 4:</span>
          <span class="dot">
            <span :class="1 <= currentStep ? 'selected' : ''"></span>
          </span>
          <span class="dot">
            <span :class="2 <= currentStep ? 'selected' : ''"></span>
          </span>
          <span class="dot">
            <span :class="3 <= currentStep ? 'selected' : ''"></span>
          </span>
          <span class="dot">
            <span></span>
          </span>
        </p>
        
        <div class="flex-1 flex flex-align-center flex-justify-end">
          <button 
            :disabled="!canNext" 
            @click="$emit('next')" 
            class="hb-btn primary p-l-unset p-r-unset sticky"
          >
            <span class="p-r-1rem p-l-1rem mobile">Next ></span>
          </button>
          
          <VDropdown :distance="6">
            <button 
              class="leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center noStick" 
              v-tooltip="{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }" 
              @click="$emit('leave-builder')"
            >
              <span class="color-link font-bold">Save </span>
              <img 
                width="20" 
                height="20" 
                src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131" 
                alt="save cart"
              />
            </button>
            <template #popper>
              <p>Saved!</p>
            </template>
          </VDropdown>
        </div>
      </div>
      
      <div class="header-action-section w-100 flex flex-align-center flex-justify-between">
        <div class="buttons-container w-100 flex flex-align-center gap-1vw">
          <button 
            v-if="currentStep != 2" 
            @click="$emit('show-filters')" 
            class="hb-btn link slim filters flex flex-align-center flex-justify-between gap-05vw"
          >
            <img 
              class="purple h-auto" 
              width="15px" 
              height="15px" 
              src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
            />
            Filters 
            <span v-if="!selectedCardsOccasions.includes('View All')">
              ({{ selectedCardsOccasions.length }})
            </span>
          </button>
          
          <button 
            v-if="currentStep == 1" 
            class="hb-btn link slim filters flex flex-align-center flex-justify-between gap-05vw" 
            @click="$emit('show-sort')"
          >
            <img 
              width="15px" 
              height="10px" 
              class="h-auto" 
              src="https://cdn.shopify.com/s/files/1/1363/8433/files/sort.svg?v=1749479130"
            />
            Sort Products
          </button>
        </div>
        
        <VDropdown :distance="6">
          <button 
            class="leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center sticky" 
            v-tooltip="{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }" 
            @click="$emit('leave-builder')"
          >
            <span class="color-link font-bold">Save </span>
            <img 
              width="20" 
              height="20" 
              src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131" 
              alt="save cart"
            />
          </button>
          <template #popper>
            <p>Saved!</p>
          </template>
        </VDropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderActions',
  
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    canNext: {
      type: Boolean,
      required: true
    },
    selectedCardsOccasions: {
      type: Array,
      required: true
    },
    currentCopy: {
      type: String,
      required: true
    },
    currentMobileCopy: {
      type: String,
      required: true
    },
    headerText: {
      type: String,
      required: true
    }
  },
  
  emits: ['back', 'next', 'show-filters', 'show-sort', 'leave-builder']
}
</script>

<style scoped>
.header-actions-wrapper {
  position: sticky;
  top: -1px;
  max-height: 60px;
  padding-right: 12%;
}

.header-actions-wrapper.isSticky {
  z-index: 99;
  padding-right: 2rem;
  background-color: #fffdfa;
  box-shadow: 0 1px 2px -1px #0000004d;
}

.header-actions-wrapper.isSticky .step-text {
  display: none;
}

.header-actions-wrapper .steps {
  display: none;
}

.header-actions-wrapper.isSticky .steps {
  display: flex;
}

.header-actions-wrapper .sticky {
  display: none;
}

.header-actions-wrapper.isSticky .sticky {
  display: flex;
}

.header-actions-wrapper.isSticky .noStick {
  display: none;
}

.header-actions-wrapper.isSticky .between-sticky {
  justify-content: space-between;
}

.steps .dot {
  display: flex;
  align-items: center;
  padding: 0.5%;
  border-radius: 50%;
  margin: 0% 0.5%;
}

.steps .dot span {
  height: 0.6vw;
  width: 0.6vw;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}

.steps .dot span.selected {
  opacity: 1;
}

@media screen and (max-width: 767px) {
  .header-actions-wrapper {
    padding: 1rem;
    max-height: unset;
  }
  
  .steps .dot span {
    width: 2vw;
    height: 2vw;
  }
}
</style>
